export default __webpack_public_path__ + "static/media/section4-right.1a4df644.png";